import type { WelcomeMessageContentType } from '@aytm/app/insights/dashboard/components/blocks/WelcomeOverlay/types'

export const welcomeMessageContent: WelcomeMessageContentType = {
  title: 'Notice: Updates to Insight Portal',
  //   subtitle: 'Please read the following information carefully',
  message:
    'Updates to the Insight Portal make it impossible to restore some of your previous customizations, such as hidden columns. While we will minimize such instances in the future, please review the layout of the current table (and possibly other reports) to ensure that all pertinent information is accurate and up to date. Thank you!',
  buttonLabel: 'Proceed',
  isButtonSecondary: false,
  isWarning: false,
  isError: false
}
